// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const clientV1Bridge = require('client-v2/common/client-v1-bridge')
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const routerActions = require('client-v2/common/state/router/actions')
const searchActions = require('client-v2/common/state/search/actions')
// Sibling imports
const AppHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    hidden: state.env.nativeEmbedded,
    user: state.user.loggedIn ? state.user : null
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onSearchNavigate: dispatchAction(routerActions.navigate),
    onSearchSubmit: dispatchAction(searchActions.navigateToArticleSearch),
    // Logged-in actions
    onAddClick: () => clientV1Bridge.showAddUrlModal(),
    onProfileClick: dispatchAction(userActions.navigateToUserProfile),
    // Logged-out actions
    onLoginClick: dispatchAction(authModalActions.showLogin),
    onSignupClick: dispatchAction(authModalActions.showSignup)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    AppHeader
  )
)
